export function getBrowserTabTitle(docName?: string) {
    return docName ? `${docName} (document)` : 'Documents';
}
